
import cmBlank from '@/components/cmBlank.vue'
import cmLoadmore from '@/components/cmLoadmore.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Previewer from 'vux/src/components/previewer/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import Group from 'vux/src/components/group/index.vue'
import PopupHeader from 'vux/src/components/popup-header/index.vue'
import Checklist from 'vux/src/components/checklist/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'


export default {
name: 'order',
directives: {
TransferDom
},
components: {
cmBlank,cmLoadmore,PopupPicker,Previewer,Popup,XButton,Radio, Group,PopupHeader,Checklist,XTextarea,Datetime
},
data () {
return {
title:'全部订单',
startDate:'',
minHour:6,
maxHour:20,
minuteList:['00','30'],
popBg:false,
timePop:false,
datetimeStatus:false,
isActive:0,
blankShow:false,
loadStatus:false,
showCommentStatus:false,
showResetStatus:false,
showCancelStatus:false,
loadmoreText:'正在加载。。。',
busy:false,
phone:'',
pageFlag:2,
hasNext:0,
lastId:0,
id:0,
itemId:0,
list:[],
pickerGroupStatus:false,
pickerWorkerStatus:false,
check:'/static/images/start@2x.png',
checked:'/static/images/started@2x.png',
group:[],
groupId:0,
worker:[],
workerId:[],
grade:0,
pay_status:'',
scope:0,
content:'',
commented:'',
isAssign:0,
waitPay:0,
statusArr:[
{
key:'',
value:'全部',
},
{
key:0,
value:'未支付',
},
{
key:1,
value:'已支付'
},
],
orderScope:[
{
key:0,
value:'全部'
},
{
key:1,
value:'本人订单'
},
{
key:2,
value:'组员订单'
},
],

dateList: [],
dateStr: '',
home_time: '',
old_home_time: '',
}
},
created(){
this.isActive = Number(this.$route.params.i);
this.commented = this.$route.params.commented;
this.grade = parseInt(this.$func.getLocal('grade'));
this.setDate();

},
mounted(){
if(this.grade == 14){
this.getCurtainGroup();
this.getCurtainOrderPayCount();
}
if(this.grade == 23 || this.grade == 24){
this.buildDateList();
}
if(this.grade == 23){
this.getWorker();
}
},
methods:{
async buildDateList(){
const weekMap = ['周日','周一','周二','周三','周四','周五','周六'];
const list = [];
const mkDate = await this.getCurtainOrderDateCount();
list.push({ value: '', label: '全部', display: '' ,num:mkDate.all});
console.log(mkDate);
for(let i=0;i<7;i++){
const d = new Date();
d.setDate(d.getDate()+i);
const yyyy = d.getFullYear();
const mm = String(d.getMonth()+1).padStart(2,'0');
const dd = String(d.getDate()).padStart(2,'0');
const value = `${yyyy}-${mm}-${dd}`;
let label = '';
let display = '';
let num = 0;
if(i===0){
label = '今天';
display = `${mm}-${dd}`;

} else if(i===1){
label = '明天';
display = `${mm}-${dd}`;
} else if(i===2){
label = '后天';
display = `${mm}-${dd}`;
} else {

label = `${mm}-${dd}`;

display = weekMap[d.getDay()];
}
num = mkDate[display] || 0;
list.push({ value, label, display,num });
}
this.dateList = list;
console.log(this.dateList);
},
async getCurtainOrderDateCount(){
try{
const res = await this.$api.getCurtainOrderDateCount({status:this.isActive});
return res ? res.data : {};
}catch(e){
console.error('getCurtainOrderDateCount error', e);
return {};
}
},
async getCurtainOrderPayCount(){
try{
const res = await this.$api.getCurtainOrderPayCount({status:this.isActive});
this.waitPay = res.data || 0;
}catch(e){
console.error('getCurtainOrderDateCount error', e);
return {};
}
},
selectDate(val){
this.dateStr = val;
this.list = [];
this.lastId = 0;
this.hasNext = 0;
this.getList();
},
setDate() {
var nowDate = new Date();
var date = {
year: nowDate.getFullYear(),
month: nowDate.getMonth() + 1,
day: nowDate.getDate(),
}
this.startDate = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
},
datetimeChange(val){
this.home_time = val;
},
editHomeTime(id,index){
this.itemId = id;
this.home_time = this.list[index].home_time;
this.old_home_time = this.list[index].home_time;
this.popBg = true;
this.timePop = true;
},
submitEditHomeTime(){
if(!this.itemId){
this.$func.showToast('操作失败，请稍后再试');
return false;
}
if(!this.home_time){
this.$func.showToast('请选择上门时间');
return false;
}
if(this.home_time == this.old_home_time){
if(this.isAssign > 0){
this.datetimeStatus = false;
this.popBg = false;
this.timePop = false;
this.pickerWorkerStatus = true;
return ;
}
}
this.$func.confirm('确认操作？','提示',()=>{
this.$api.curtainEditHomeTime({id:this.itemId,home_time:this.home_time}).then((res)=>{
if(res){
if(this.isAssign > 0){
this.datetimeStatus = false;
this.popBg = false;
this.timePop = false;
this.pickerWorkerStatus = true;
}else{
setTimeout(()=>{
this.datetimeStatus = false;
this.popBg = false;
this.timePop = false;
this.list = [];
this.lastId = 0;
this.hasNext = 0;
this.itemId = 0;
this.loadmore();
}, 300);
}
}
});
})
},
payStatus(id){
this.$func.confirm('确认已付款？','提示',()=>{
this.$api.curtainPayStatus({id:id}).then((res)=>{
if(res){
setTimeout(()=>{
this.datetimeStatus = false;
this.list = [];
this.lastId = 0;
this.hasNext = 0;
this.loadmore();
}, 300);
}
});
})
},
copy(val){
this.$func.copy(val,event);
},
reset(){
this.phone = '';
this.pay_status = '';
this.list = [];
this.lastId = 0;
this.hasNext = 0;
this.getList();
},
search(){
this.list = [];
this.lastId = 0;
this.pay_status = '';
this.hasNext = 0;
this.getList();
},
selectStatus(key){
this.loadStatus = false;
this.pay_status = key;
this.lastId = 0;
this.list = [];
this.getList();
},
selectScope(key){
this.loadStatus = false;
this.scope = key;
this.lastId = 0;
this.list = [];
this.getList();
},
getList(){
this.$api.getCurtainOrder({last_id:this.lastId,page_flag:this.pageFlag,phone:this.phone,pay_status:this.pay_status,status:this.isActive,commented:this.commented,scope:this.scope,home_date:this.dateStr}).then((res)=>{
if(res){

if(!this.lastId){
this.blankShow = res.data.length > 0 ? false : true;
}
this.hasNext = res.hasNext;
this.lastId = res.lastId;
res.data.forEach((item)=>{
this.list.push(item);
});
}
})
},
changeStatus(id,status){
if(!id){
this.$func.showToast('操作失败，请稍后再试');
return false;
}
if(status == 2 && !this.groupId){
this.$func.showToast('请选择拆装组');
return false;
}
if(status == 3 && !this.workerId.length){
this.$func.showToast('请选择拆装师傅');
return false;
}
this.$func.confirm('确认操作？','提示',()=>{
this.$api.changeCurtainStatus({id:id,status:status,groupId:this.groupId,workerId:this.workerId}).then((res)=>{
if(res){
this.$func.showToast('操作成功');
setTimeout(()=>{
this.pickerGroupStatus = false;
this.pickerWorkerStatus = false;
this.list = [];
this.lastId = 0;
this.itemId = 0;
this.hasNext = 0;

this.loadmore();
}, 300);
}
});
})
},
grabOrder(id){
if(!id){
this.$func.showToast('操作失败，请稍后再试');
return false;
}
this.$func.confirm('确认抢单？','提示',()=>{
this.$api.curtainGrabOrder({id:id}).then((res)=>{
if(res){
this.$func.showToast('操作成功');
setTimeout(()=>{
this.list = [];
this.lastId = 0;
this.hasNext = 0;

this.loadmore();
}, 300);
}
});
})
},
curtainOrderEdit(id){
this.$router.push({name:'createCurtainOrder',params:{id:id}})
},
detail(id){
this.$router.push({name:'curtainOrderInfo',params:{id:id}})
},
assignGroup(id){
this.itemId = id;
this.pickerGroupStatus = true;
},
onGroupChange (value) {
this.groupId = value;
},
assignWorker(id,index){
this.itemId = id;
this.isAssign = 1;
this.editHomeTime(id,index);

},
onWorkerChange (value) {
this.workerId = value;
},
getCurtainGroup() {
this.$api.getCurtainGroup({}).then((res)=>{
if(res){
this.group = res.data;
}
})
},
getWorker() {
this.$api.getCurtainWorker({}).then((res)=>{
if(res){
this.worker = res.data;
}
})
},
closePop(){
this.popBg = false;
this.timePop = false;
},
showComment(id){
this.itemId = id;
this.content = '';
this.showCommentStatus = true;
},
submitComment(){
if(!this.itemId){
this.$func.showToast('操作失败，请稍后再试');
return false;
}
if(!this.content){
this.$func.showToast('请输入回访结果');
return false;
}
this.$func.confirm('确认操作？','提示',()=>{
this.$api.curtainComment({id:this.itemId,content:this.content}).then((res)=>{
if(res){
this.$func.showToast('操作成功');
setTimeout(()=>{
this.showCommentStatus = false;
this.list = [];
this.lastId = 0;
this.hasNext = 0;

this.loadmore();
}, 300);
}
});
})
},
resetCurtainOrderStatus(id){
this.itemId = id;
this.content = '';
this.showResetStatus = true;
},
submitReset(){
if(!this.itemId){
this.$func.showToast('操作失败，请稍后再试');
return false;
}
if(!this.content){
this.$func.showToast('请输入订单重置原因');
return false;
}
this.$func.confirm('确认操作？','提示',()=>{
this.$api.resetCurtainOrder({id:this.itemId,content:this.content}).then((res)=>{
if(res){
this.$func.showToast('操作成功');
setTimeout(()=>{
this.showResetStatus = false;
this.list = [];
this.lastId = 0;
this.hasNext = 0;

this.loadmore();
}, 300);
}
});
})
},
cancelCurtainOrder(id){
this.itemId = id;
this.content = '';
this.showCancelStatus = true;
},
submitCancel(){
if(!this.itemId){
this.$func.showToast('操作失败，请稍后再试');
return false;
}
if(!this.content){
this.$func.showToast('请输入订单撤销原因');
return false;
}
this.$func.confirm('确认操作？','提示',()=>{
this.$api.cancelCurtainOrder({id:this.itemId,content:this.content}).then((res)=>{
if(res){
this.$func.showToast('操作成功');
setTimeout(()=>{
this.showCancelStatus = false;
this.list = [];
this.lastId = 0;
this.hasNext = 0;

this.loadmore();
}, 300);
}
});
})
},
loadmore(){
if(this.lastId > 0 && !this.hasNext){
this.busy = true;
this.loadStatus = true;
this.loadmoreText = '没有更多了。。。'
return ;
}
this.busy = true;
this.loadStatus = true;
this.loadmoreText = '正在加载。。。';

this.getList();
setTimeout(()=>{
if(this.blankShow){
this.busy = true;
this.loadStatus = false;
this.loadmoreText = '没有更多了。。。'
}else{
if(this.hasNext > 0){
this.loadStatus = false;
this.busy = false;
}else{
this.busy = true;
this.loadStatus = true;
this.loadmoreText = '没有更多了。。。'
}
}
},1500)
}
}
}



// WEBPACK FOOTER //
// ./src/pages/curtainOrder.vue